import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import CategorieServise from '@/Services/CategorieService';
import { Categorie } from '@/models/Categorie';
@Module({ namespaced: true })
export default class CategorieModule extends VuexModule {
    Categories: Categorie[] = [];
    error: string | null = null;
    @Mutation
    setProduits(Categories: Categorie[]) {
        this.Categories = Categories;
    }
    @Mutation
    setError(error: string | null) {
        this.error = error;
    }

    @Action
    async fetchCategories() {
        try {
            const response = await CategorieServise.getAllCategories();
            return response
        } catch (error: any) {
            return error;
        }
    }
    get getAll() {
        return this.Categories;
    }

}
